import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GameFiltrationDto } from '../../models/GameFiltrationDto';
import { MummyGameService } from '../../services/mummy-game.service';
import { Globals } from 'projects/shared/models/Globals';
import { GenericResponseContract } from 'projects/shared/models/GenericResponseContract';


declare var parentId: any;
declare var Level: any;
declare var $: any;

@Component({
  selector: 'app-mummy-game',
  templateUrl: './mummy-game.component.html',
  styleUrls: []
})
export class MummyGameComponent implements OnInit,AfterViewInit {
  @ViewChild('audioElement') audioElement: ElementRef;

  TotalScore = 0;
  gameEnded: boolean = false;
  lastQ: boolean = false;

  input = new GameFiltrationDto(parentId, null, null, Globals.MummyGameDetailsCrop);
  gameContent: any;
  public ViewLocalizedResources = Globals.ViewLocalizedResources;
  rtl = Globals.Culture == "ar";
  slideConfig = {
    "vertical": false,
    "verticalSwiping": false,
    "infinite": false,
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "initialSlide": 1,
    "speed": 1000,
    "fade": true,
    "arrows": true,
    "centerPadding": "0px",
    "nextArrow": ".eventNextArrow",
    "prevArrow": ".eventPrevArrow",
    "rtl": this.rtl,
    "responsive": [
      {
        "breakpoint": 320,
        "settings": {
          "slidesToShow": 2,
          "slidesToScroll": 2,
          "arrows": true,
          "centerMode": true,
          "infinite": false,
          "centerPadding": '0px',
        }
      }
    ]
  };

  public result: "";
  public coinsCount: number;
  public correctResult = "";
  public answers: any[] = [];
  public takeCoins: any[] = [];
  static LeaveUrl = "";
  public audioEnabled=false;

  constructor(private apiService: MummyGameService) { }

  ngOnInit() {
    this.apiService.getMummyGameQuestions(this.input).subscribe((response: GenericResponseContract<object>) => {
      this.gameContent = response.Data,
        this.answers = this.arrayOne(this.gameContent.MummyGameQA.length),
        this.lastQ = this.gameContent.MummyGameQA.length == 1;
    });
  }

  ngAfterViewInit() {
    this.audioEnabled=$('#mumyGame').is(":visible");
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }
  counter(i: number) {
    return new Array(i);
  }
  checkAnswer(answer, correctAnswerNumber, coinValue, answers, questionIndex) {
    if (answer == correctAnswerNumber) {
      this.result = this.ViewLocalizedResources.ThisWasTheRightAnswer;
      this.correctResult = "";

      if (!this.answers[questionIndex]) { //&& this.answers[questionIndex] != answer
        this.TotalScore += coinValue;
        this.takeCoins[questionIndex] = true;
      }
      if (this.takeCoins[questionIndex]) {
        this.coinsCount = coinValue;
      }
      else {
        this.coinsCount = null;
      }

      this.answers[questionIndex] = answer;
      // if(questionIndex == this.gameContent.MummyGameQA.length-1 && this.answers[questionIndex]){
      //   this.gameEnded = true;
      //   //this.leaveGame();
      // }  
    }
    else if (answer != null) {
      this.takeCoins[questionIndex] = false;
      this.result = this.ViewLocalizedResources.WrongAnswer;
      this.coinsCount = null;
      this.correctResult = this.ViewLocalizedResources.TheRightAnswerIs + ":\n" + answers[correctAnswerNumber - 1];
      if (this.answers[questionIndex] != answer && this.answers[questionIndex] == correctAnswerNumber)
        this.TotalScore -= coinValue;

      this.answers[questionIndex] = answer;
      // if(questionIndex == this.gameContent.MummyGameQA.length-1 && this.answers[questionIndex]){
      //   this.gameEnded = true;
      //   //this.leaveGame();
      // }  
    }
    else {
      this.result = "";
      this.coinsCount = null;
      this.correctResult = "";
    }

  }

  beforeChange($event) {
    var question = this.gameContent.MummyGameQA[$event.nextSlide];
    this.checkAnswer(this.answers[$event.nextSlide], question.CorrectAnswer, question.CoinValue, question.Answers, $event.nextSlide);
    if ($event.nextSlide == this.gameContent.MummyGameQA.length - 1)
      this.lastQ = true;
    else
      this.lastQ = false;

  }

  closePopup() {
    this.gameEnded = false;
  }

  leaveGame(leave = false) {
    this.gameEnded = !this.gameEnded;
    if (!MummyGameComponent.LeaveUrl) {
      this.apiService.saveScore(this.TotalScore).subscribe(response => {
        leave == true ? window.open(response.toString(), '_self') : MummyGameComponent.LeaveUrl = response.toString();
      });
    }
    else {
      leave == true ? window.open(MummyGameComponent.LeaveUrl, '_self') : null;
    }
  }

  playAgain() {
    window.location.reload();
  }


  pauseAudio(){
    this.audioElement.nativeElement.pause();
  }

  playAudio(){
    this.audioElement.nativeElement.play();
  }
}
